import AssetsManager from '../../../data/AssetsManager'

/**
 * BtnViewクラス
 */
class BtnView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	BtnView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    //通常
    this.normal = new PIXI.Graphics()
    this.normal.beginFill(0xffff00)
    this.normal.drawRect(0, -3, 3, 6)
    this.normal.endFill()
    this.addChild(this.normal)

    //押した
    this.push = new PIXI.Graphics()
    this.push.beginFill(0xfe050b)
    this.push.drawRect(0, -3, 2, 6)
    this.push.endFill()
    this.addChild(this.push)

    //リセット
    this.reset()
  }

  reset()
  {
    this.normal.visible = true
    this.push.visible = false
  }

  press()
  {
    this.normal.visible = false
    this.push.visible = true
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default BtnView
